/* lua.js generated code 0.3.0 */

require("clover/config/LocalDataConfig")
var UserShareData = xClass("UserShareData")
var instance = null
UserShareData.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserShareData.create()
    }
    return instance
}
UserShareData.prototype.ctor = function () {
    var self = this
    self.datas = table()
    self.readFromFile()
}
UserShareData.prototype.incShareNum = function () {
    var self = this
    self.setData(self.getData("totalShareNum", 0) + 1)
    self.writeToFile()
}
UserShareData.prototype.getShareNum = function () {
    var self = this
    // WARN: maybe multi result
    return self.getData("totalShareNum", 0)
}
UserShareData.prototype.incDailyShareShow = function (id, value) {
    var self = this
    value = value || 1
    var record = self.getData("dailyShareShow", table())
    var found = false
    for (var i = 1, v = record[1]; v; i++, v = record[i]) {
        if (v.id === id) {
            found = true
            v.num = v.num + value
            break
        }
    }
    if (!found) {
        table.insert(record, table([1, "id", id], [1, "num", value]))
    }
    self.setData("dailyShareShow", record)
    self.writeToFile()
}
UserShareData.prototype.getDailyShareShow = function (id) {
    var self = this
    var record = self.getData("dailyShareShow", table())
    for (var i = 1, v = record[1]; v; i++, v = record[i]) {
        if (v.id === id) {
            return v.num
        }
    }
    return 0
}
UserShareData.prototype.shouldSyncTimelineStatus = function () {
    var self = this
    return !(self.getData("timelineSynced", false) && (!self.getData("timelineAvailable", false)))
}
UserShareData.prototype.getTimelineAvailable = function () {
    var self = this
    return self.getData("timelineSynced", false) && self.getData("timelineAvailable", false)
}
UserShareData.prototype.setTimelineStatus = function (status) {
    var self = this
    self.setData("timelineSynced", true)
    self.setData("timelineAvailable", status)
}
UserShareData.prototype.setData = function (keyword, value) {
    var self = this
    self.datas[keyword] = value
}
UserShareData.prototype.getData = function (keyword, xdefault) {
    var self = this
    if (type(self.datas[keyword]) !== "nil") {
        return self.datas[keyword]
    } else {
        return xdefault
    }
}
UserShareData.prototype.flushData = function () {
    var self = this
    self.writeToFile()
}
UserShareData.prototype.readFromFile = function () {
    var self = this
    var data = Persistence.readFileData(LocalDataFiles.kUserShare) || table()
    if (type(data.updateTime) !== "number" || data.updateTime <= 0) {
        return 
    }
    for (var k in data) {
        var v = data[k]
        self.datas[k] = v
    }
    var sameDay = compareDate(os.date("*t", data.updateTime / 1000), os.date("*t", Localhost.time() / 1000)) === 0
    if (!sameDay) {
        self.datas.dailyShareShow = null
    }
}
UserShareData.prototype.writeToFile = function () {
    var self = this
    var data = clone(self.datas)
    data.updateTime = Localhost.time()
    Persistence.writeFileData(data, LocalDataFiles.kUserShare)
}
module.exports = UserShareData
